export const CATEGORIES = [
  "atp250",
  "atp500",
  "grandslam",
  "masters",
  "wta1000",
  "wta250",
  "wta500",
];
